/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-settlement-detail-title',
    templateUrl: './settlement-detail-title.component.html',
    styleUrls: ['./settlement-detail-title.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SettlementDetailTitleComponent {
    @Input() sectionTitle: string;

    createDataCy(title: string): string {
        let dataCy = `settlement-detail-section-title`;
        if (title != null && title.length > 0) {
            dataCy = `${dataCy}-${title.replace(' ', '-')}`;
        }
        return dataCy;
    }
}
